import { styled, TextField } from '@mui/material'; // eslint-disable-line @typescript-eslint/no-restricted-imports

const UnlockedTextField = styled(TextField, {
  name: 'LockableTextField',
  slot: 'Unlocked',
  overridesResolver: (_, styles) => styles.unlocked,
})({});

export default UnlockedTextField;
